import { useEffect, useState } from 'react';
import SnackBar from 'components/SnackBar';
import FormGroup from '../../FormGroup';
import SectionHeader from '../../SectionHeader';
import usePostData from '../../../hooks/usePostData';
import useFetchData from '../../../hooks/useFetchData';
import fields from '../fields';
import { useParams } from 'react-router-dom';
import '../styles.scss';

const SurveyMeasurePage = () => {
  const { idd } = useParams();
  const [currentMeasure, setCurrentSurveyMeasure] = useState();
  const { postData, res, payload, error } = usePostData();
  const [showSnackbar, setShowSnakbar] = useState(false);
  const [errFun, setErrFun] = useState();

  let { data } = useFetchData('survey-measures', idd);
  useEffect(() => {
    setCurrentSurveyMeasure(data);
  }, [data]);

  useEffect(() => {
    if (error)
      errFun?.set('apiError', {
        type: 'string',
        message: error.apiError
      });
    else if (res && res.affected === 1 && payload) {
      setCurrentSurveyMeasure(payload);
      setShowSnakbar(true);
    }
  }, [res, payload, error]);

  const onSubmit = (data, setError) => {
    setErrFun({ set: setError });
    let deepData = { ...data };
    delete deepData.id;
    for (const a in deepData) {
      if (deepData[a] == '') deepData[a] = null;
    }
    console.log('update measure data  :', deepData);
    postData(`survey-measures/${idd || 'measures'}`, deepData, 'patch');
  };

  return (
    <div>
      {currentMeasure && (
        <div>
          <SectionHeader title={`${currentMeasure?.name}`}></SectionHeader>
          <FormGroup
            fields={fields()}
            data={currentMeasure}
            onSubmit={onSubmit}
          ></FormGroup>
          {showSnackbar && (
            <SnackBar
              msg={'מדד עודכן'}
              handleClose={() => setShowSnakbar(false)}
            ></SnackBar>
          )}
        </div>
      )}
    </div>
  );
};

export default SurveyMeasurePage;
